import React, { useEffect } from 'react';
import './tasks.css';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import TasksHeader from "../../components/PagesHeaders/TasksHeader/TasksHeader";
import TaskForm from "../../components/TaksForm/TaskForm";
import { getTasksSagaAction } from "../../redux/sagaActions";
import Task from "../../components/Task/Task";

const Tasks = () => {
    const dispatch = useDispatch();

    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const task_form = useSelector(state => state.task_form);
    const tasks = useSelector(state => state.tasks);
    const task_archive = useSelector(state => state.task_archive);

    useEffect(() => {
        if (!currentEstablishment) return;

        dispatch(getTasksSagaAction());
    }, [currentEstablishment, task_archive]);

    return (
        <>
            <Header component={ <TasksHeader/> }/>
            { task_form.open && <TaskForm /> }
            <div className="page">
                <div className="page__content">
                    <div className="tasks">
                        {
                            tasks?.map(elem => {
                                return <Task data={ elem } key={ elem.id } />;
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Tasks;